import { Switch } from "../ui/switch";
import RichTextEditor from "./RichTextEditor";
import MediaPicker from "./MediaPicker";

// type: text | textarea | number | switch | select | lines | richtext | image | date | password | prices | tiers
export default function FieldInput({ field, value, onChange }) {
  const id = `f-${field.name}`;
  const common = { id, className: "field-input text-sm", "data-testid": `field-${field.name}` };
  switch (field.type) {
    case "textarea": return <textarea rows={4} {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />;
    case "number": return <input type="number" step="any" {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))} />;
    case "switch": return <Switch id={id} checked={!!value} onCheckedChange={onChange} data-testid={`field-${field.name}`} />;
    case "select": return (
      <select {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)}>
        {field.options.map((o) => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}
      </select>);
    case "lines": return <textarea rows={5} {...common} value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} />;
    case "richtext": return <RichTextEditor id={id} label={field.label} value={value || ""} onChange={onChange} />;
    case "image": return <MediaPicker id={id} value={value} onChange={onChange} />;
    case "date": return <input type="date" {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />;
    case "password": return <input type="password" autoComplete="new-password" {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />;
    case "prices": return (
      <div className="grid grid-cols-2 gap-3">
        {["in_person", "virtual"].map((m) => (
          <label key={m} className="text-xs">{m === "in_person" ? "In-person" : "Virtual"}
            <input type="number" min="0" className="field-input text-sm" value={value?.[m] ?? ""} data-testid={`field-prices-${m}`}
              onChange={(e) => onChange({ ...value, [m]: Number(e.target.value) })} /></label>
        ))}
      </div>);
    case "tiers": return <TiersInput value={value || []} onChange={onChange} />;
    default: return <input type="text" {...common} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />;
  }
}

export const cleanLines = (field, v) => (field.type === "lines" ? (v || []).map((s) => s.trim()).filter(Boolean) : v);

// Date-based price tiers. starts_at/ends_at: ISO date-time (Nassau time if no offset), "cutoff" (event price cutoff), or blank (open).
const TIER_KEYS = [["label", "Label"], ["price", "Price"], ["starts_at", "Starts (blank/cutoff/ISO)"], ["ends_at", "Ends before (blank/cutoff/ISO)"]];
function TiersInput({ value, onChange }) {
  const upd = (i, k, v) => onChange(value.map((t, j) => (j === i ? { ...t, [k]: k === "price" ? Number(v) : v } : t)));
  return (
    <div className="space-y-2" data-testid="field-price_tiers">
      {value.map((t, i) => (
        <div key={i} className="grid grid-cols-2 gap-2 rounded border p-2 md:grid-cols-5">
          {TIER_KEYS.map(([k, l]) => <input key={k} aria-label={`Tier ${i + 1} ${l}`} placeholder={l} className="field-input text-xs" type={k === "price" ? "number" : "text"}
            value={t[k] ?? ""} onChange={(e) => upd(i, k, e.target.value)} data-testid={`tier-${i}-${k}`} />)}
          <button type="button" className="btn-outline btn-sm" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`tier-${i}-remove`}>Remove</button>
        </div>))}
      <button type="button" className="btn-outline btn-sm" onClick={() => onChange([...value, { label: "", price: 0, starts_at: "", ends_at: "" }])} data-testid="tier-add-btn">Add tier</button>
    </div>
  );
}
